import React, { useState, useEffect } from 'react';
import './ActiveList.css';
import { fetchMarketingUser, uploadFile } from "../Services/Service";
import Table from './DataTable/DataTable';
import * as XLSX from 'xlsx';
import { CustomLoader, formatDate_dMYHiP } from "../Services/CommonLibrary"
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUploadText from './FileUploadText';
import UpdateSummary from './UpdateSummary';
import FileUploadTabNew from './FileUploadTabNewSummary';
import ExcelJS from 'exceljs';




const UploadSummary = () => {

    const [serviceData, setServiceData] = useState([]);
    const [consultationData, setConsultationData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startRange, setStartRange] = useState('');
    const [endRange, setEndRange] = useState('');
    const [file, setFile] = useState('');
    const [patientMobile, setPatientMobile] = useState('');
    const [isToastOpen, setIsToastOpen] = useState(false);
    const [programNames, setProgramData] = useState(false);
    const [practiceNames, setPraticeData] = useState(false);
    const [divisions, setDivisionData] = useState(false);


    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const showToastMessage = (type, msg) => {
        toast.dismiss();
        toast[type](msg);
    };




    const handleChange = (e) => {
        const MAX_FILE_SIZE = 1024 * 30;

        const file = e.target.files[0]; // accesing file
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
            alert("File size should be less than 30 MB");
            document.getElementById(e.target.id).value = "";
            return
        }

        setFile(file);
    }

    useEffect(() => {
        fetchActiveList();
        // showToastMessage('success','Summary Uploaded');
    }, []);

    const fetchActiveList = async () => {
        fetchMarketingUser()
            .then((res) => {
                setServiceData(res.data.data);
                setProgramData(res.data.programs);
                setPraticeData(res.data.pratice);
                setDivisionData(res.data.divison);
                setLoading(false);
            }
            );
    }

    const uploadFile_Html = async (e) => {

        if (file != '') {
            setLoading(true);
            const formData = new FormData();
            formData.append('file', file); // appending file
            formData.append('type', e.target.id); // appending file

            formData.append('uploadtype', 'marketingUser');  // appending file
            formData.append('mobile', patientMobile);

            // console.log('form',patientMobile)

            uploadFile(formData).then((response) => {
                if (typeof (response) !== 'undefined') {
                    showToastMessage('success', 'Summary Uploaded');
                    fetchActiveList();
                    setLoading(false);
                    setShowModal(false);
                }
                document.getElementById("allFile_new").value = "";
            }
            );
        } else {
            showToastMessage('error', 'Please select file');
        }
    }


    const viewPopup = (mobile) => {
        setPatientMobile(mobile);
        setShowModal(true)
    }

    const handleDownloadExcel = async () => {
        const workbook = new ExcelJS.Workbook();
    
        const ws = workbook.addWorksheet('Patient Data');
    
        // Add headers to the main worksheet
        ws.addRow(['Practice Name', 'Doctor Email', 'NHS Number', 'Patient Name', 'Patient Email', 'Patient Mobile', 'Program Name', 'Division']);
    
        // Set column widths for the main worksheet
        ws.columns = [
            { header: 'Practice Name', key: 'practiceName', width: 18 },
            { header: 'Doctor Email', key: 'doctorEmail', width: 18 },
            { header: 'NHS Number', key: 'nhsId', width: 18 },
            { header: 'Patient Name', key: 'patientName', width: 18 },
            { header: 'Patient Email', key: 'patientEmail', width: 18 },
            { header: 'Patient Mobile', key: 'patientMobile', width: 18 },
            { header: 'Program Name', key: 'programName', width: 18 },
            { header: 'Division', key: 'division', width: 18 },
        ];
    
        
    
        // Add data rows to the main worksheet
        serviceData.forEach((item) => {
            ws.addRow({
                practiceName: item.practiceName,
                doctorEmail: item.doctorEmail,
                nhsId: item.nhsId,
                patientName: item.patientName,
                patientEmail: item.patientEmail,
                patientMobile: item.patientMobile,
                programName: item.programName,
                division: item.division,
            });
        });
    
        
        // Create and populate the Practice Names sheet
        const practiceNamesSheet = workbook.addWorksheet('Practice Names');
        practiceNames.forEach((name) => {
            practiceNamesSheet.addRow([name]);
        });

        practiceNamesSheet.columns = [{ width: 35 }];  // Set column width
    
        // Create and populate the Program Names sheet
        const programNamesSheet = workbook.addWorksheet('Program Names');
        programNames.forEach((name) => {
            programNamesSheet.addRow([name]);
        });
        programNamesSheet.columns = [{ width: 42 }];  // Set column width

    
        // Create and populate the Divisions sheet
        const divisionsSheet = workbook.addWorksheet('Divisions');
        divisions.forEach((name) => {
            divisionsSheet.addRow([name]);
        });
        divisionsSheet.columns = [{ width: 26 }];  // Set column width

    
        // Generate Excel file
        const excelBlob = await workbook.xlsx.writeBuffer();
        const excelUrl = URL.createObjectURL(
            new Blob([excelBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        );
    
        // Download Excel file
        const link = document.createElement('a');
        link.href = excelUrl;
        link.download = 'patient_data.xlsx';
        document.body.appendChild(link);
        link.click();
    
        // Clean up
        URL.revokeObjectURL(excelUrl);
        document.body.removeChild(link);
    };

    

    const columns = [
        { name: "#", cell: (row, index) => index + 1, sortable: false, grow: 0 },
        // { name: <div className='tdData'>Name</div>, cell: row => row.patientName, selector: row => row.createdTime, sortable: true },
        // { name: <div className='tdData'>NHS ID</div>, cell: row => row.nhsNumber, selector: row => row.dateScheduled, sortable: true },
        { name: <div className='tdData'>Mobile Number</div>, selector: row => row.patientMobile, sortable: true },
        { name: <div className='tdData'>Program Name</div>, selector: row => row.programName, sortable: true },
        { name: <div className='tdData'>Uploaded on</div>, selector: row => row.uploadDate, sortable: true },
        { name: <div className='tdData'>Conscent Received On</div>, selector: row => row.consentDate, sortable: true },
        // {
        //     name: <div className='tdData'>Upload Summary</div>,
        //     button: true,
        //     cell: row => {
        //         return <button className='btn btn-secondary btn-sm btn-edit' onClick={(e) => viewPopup(row.patientMobile)}>Add Details</button>
        //     }
        // }
    ];
    const modalbody = "<span>HELLO BODY</span>";

    return (
        <section className='projects-section'>

            <div className='container'>
                <ToastContainer />
            </div>
            <FileUploadTabNew  onReload={fetchActiveList}/>

            <div className='row'>
                <div className="FL">

                    <div className='table-responsive' id="inclinicListNew">
                        <div class="row mt-4">
                            <div class="col">
                                <h1 class="title">Consented Patients</h1>
                            </div>
                            <div class="col-auto">
                            <Button onClick={handleDownloadExcel}>Download Consent Data</Button>
                            </div>
                        </div>
                        <Table data={serviceData} column={columns}  show="N"/>
                    </div>
                </div>
            </div>
            {loading ? <CustomLoader /> : null}

            {showModal ?
                <>

                    <Modal dialogClassName="modal-xl" show={showModal} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Upload Patient Health Data</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <div className='row'>
                                <div className="file-upload">
                                    <div className="row ">

                                        <div className="col-md-12 col-xl-12">
                                            <UpdateSummary />

                                        </div>

                                        {/* <div className="col-md-12 col-xl-12 mt-5">
                                            <button onClick={uploadFile_Html} className="btn btn-primary btn-login" id="allSubmit">
                                                Upload Patient Medical Summary
                                            </button>
                                        </div> */}
                                    </div>
                                </div>

                            </div>

                        </Modal.Body>
                        <Modal.Footer>

                        </Modal.Footer>
                    </Modal>
                </>
                : null
            }
            {/* 
            {showModal ?
                <>

                    <Modal dialogClassName="modal-md" show={showModal} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Upload Patient Health Data</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <div className='row'>
                                <div className="file-upload">
                                    <div className="row ">

                                        <div className="col-md-12 col-xl-12">
                                            <input type="file" id="allFile_new" className="btn-upload" accept="application/pdf,.zip,.7zip" required="required" onChange={handleChange} />

                                            <span>Allowed file type :- .pdf</span><br></br>
                                            <span>File size :- 30 MB</span>

                                        </div>

                                        <div className="col-md-12 col-xl-12 mt-5">
                                            <button onClick={uploadFile_Html} className="btn btn-primary btn-login" id="allSubmit">
                                                Upload Patient Medical Summary
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </Modal.Body>
                        <Modal.Footer>

                        </Modal.Footer>
                    </Modal>
                </>
                : null
            } */}

        </section>



    );
}
export default UploadSummary;